import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
// import { CSSTransition, Transition } from 'react-transition-group';
import Address from '../../../../common/ui/Address';

class EventDetails extends Component {
  constructor(props) {
    super(props);

    this.toggleEventDetails = this.toggleEventDetails.bind(this);

    this.state = {
      showDetails: false,
    };
  }

  toggleEventDetails() {
    this.setState(prevState => ({
      showDetails: !prevState.showDetails,
    }));
  }

  render() {
    const { event, success } = this.props;
    const { showDetails } = this.state;

    const hasDetails = event
      ? event.venue_name || event.address_1 || event.city || event.attire || event.note
      : null;

    return (
      <Fragment>
        {event && (
          <div
            className={`entity-section-title event-section-title${
              success ? ' event-section-title-success' : ''
            }`}
          >
            <h2 className="event-name">{event.name}</h2>
            <h4 className="event-date">
              {moment.utc(event.start_at).format('dddd, MMMM D, YYYY')}
            </h4>
            <h4 className="event-time">
              {moment.utc(event.start_at).format('h:mm a')}
              {event.end_at && ` - ${moment.utc(event.end_at).format('h:mm a')}`}
            </h4>
            <div className="hidden-xs">
              <Address
                name={event.venue_name}
                address1={event.address_1}
                address2={event.address_2}
                city={event.city}
                state={event.state_province}
                zip={event.postal_code}
                countryCode={event.country_code}
              />
              {event.attire && <p className="event-note">{event.attire}</p>}
              {event.note && <p className="event-note">{event.note}</p>}
            </div>
            <div className="visible-xs">
              {hasDetails && (
                <a role="button" onClick={this.toggleEventDetails}>
                  {showDetails ? (
                    <div className="toggle-details-button">
                      Hide Location &amp; Details{' '}
                      <i className="zolaicon zolaicon-public-chevron-up" aria-hidden="true" />
                    </div>
                  ) : (
                    <div className="toggle-details-button">
                      View Location &amp; Details{' '}
                      <i className="zolaicon zolaicon-public-chevron-down" aria-hidden="true" />
                    </div>
                  )}
                </a>
              )}
              <div className={`event-details${showDetails ? ' expanded' : ''}`}>
                <Address
                  name={event.venue_name}
                  address1={event.address_1}
                  address2={event.address_2}
                  city={event.city}
                  state={event.state_province}
                  zip={event.postal_code}
                  countryCode={event.country_code}
                />
                {event.attire && <p className="event-note">{event.attire}</p>}
                {event.note && <p className="event-note">{event.note}</p>}
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

EventDetails.propTypes = {
  event: PropTypes.shape({}),
  success: PropTypes.bool,
};

export default EventDetails;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpForm/EventDetails.jsx